import React from 'react';
import { AppLayout } from '../../layouts/AppLayout';
import { PageHeader } from '../../layouts/PageHeader';
import { useClientManagementData } from '../../../hooks/useClientManagementData';
import { ClientManagement } from './index';

export const ClientManagementPage: React.FC = () => {
  const { clients, periodData, summaryByPeriod, loading, error } = useClientManagementData();

  if (error) {
    return (
      <AppLayout>
        <PageHeader title="Client Management" />
        <div className="p-6 flex items-center justify-center min-h-[40vh]">
          <div className="text-center">
            <p className="text-red-600 font-medium mb-1">Failed to load data</p>
            <p className="text-slate-500 text-sm">{error}</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      {/* PageHeader receives the FilterBar via the `filters` slot — rendered inside ClientManagement */}
      <ClientManagement
        clients={clients}
        periodData={periodData}
        summaryByPeriod={summaryByPeriod}
        loading={loading}
      />
    </AppLayout>
  );
};

export default ClientManagementPage;
